import { captureException } from '@sentry/react'

// This function takes the error from the Boomerang API response
// and converts it to a simplified format that can be used in the form.
//
// Example input:
// [
//   {
//       "code": "unprocessable_entity",
//       "status": "422",
//       "title": "Validation Error",
//       "detail": "Title can't be blank",
//       "source": {
//           "pointer": "/data/attributes/title"
//       },
//       "meta": {
//           "attribute": "title",
//           "message": "can't be blank",
//           "code": false
//       }
//   }
// ]
//
// Example output:
// {
//   "title": [
//       "can't be blank"
//   ]
// }
export function normalizeBoomerangErrors (errors) {
  return errors.reduce((acc, error) => {
    const fieldName = error.source?.pointer?.split('/').reverse()[0]

    if (fieldName) {
      acc[fieldName] ||= []
      acc[fieldName].push(error.meta.message)
    } else {
      captureException(
        new Error('Expected JSON:API error object to include .source.pointer but it was not found in: ' +
          JSON.stringify(error))
      )
    }

    return acc
  }, {})
}
